import { render } from "./FlipCoinHistory.vue?vue&type=template&id=c06e2d9a"
import script from "./FlipCoinHistory.vue?vue&type=script&lang=js"
export * from "./FlipCoinHistory.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__